import { render, staticRenderFns } from "./ModattaDashboardEmptyScreen.vue?vue&type=template&id=665cb00e"
import script from "./ModattaDashboardEmptyScreen.vue?vue&type=script&lang=js"
export * from "./ModattaDashboardEmptyScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports